import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { accountsKeys } from '../api';
import { useAppSettingsStore } from '@/shared/lib';

type Props = {
  userId?: string;
};

type RefetchOptions = {
  cancelRefetch?: boolean;
};

export const useAccountsRefetch = ({ userId }: Props) => {
  const queryClient = useQueryClient();
  const { baseAsset } = useAppSettingsStore();

  const refetchRestsOnly = useCallback(
    ({ cancelRefetch }: RefetchOptions = {}) =>
      queryClient.invalidateQueries({
        queryKey: [accountsKeys.rests, userId, baseAsset],
        exact: false,
        ...(cancelRefetch === undefined ? {} : { cancelRefetch }),
      }),
    [queryClient, userId, baseAsset]
  );

  const refetchAll = useCallback(
    ({ cancelRefetch }: RefetchOptions = {}) =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: [accountsKeys.info, userId],
          ...(cancelRefetch === undefined ? {} : { cancelRefetch }),
        }),
        refetchRestsOnly({ cancelRefetch }),
      ]),
    [queryClient, userId, refetchRestsOnly]
  );

  return { refetchAll, refetchRestsOnly };
};
